module.exports = __webpack_public_path__ + "img/live.5b7a6fd1.png";